import { Fragment, MutableRefObject } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import CrossIcon from '../icons/CrossIcon'
import classNames from 'classnames'

type PropTypes = {
  isOpen: boolean
  initialFocusRef?: MutableRefObject<any>
  title: React.ReactNode
  content: React.ReactNode
  actions?: React.ReactNode[]
  onClose?: () => void
  size?: 'sm' | 'md' | 'lg'
}

export default function Modal ({ isOpen = false, initialFocusRef, title, content, actions, onClose, size }: PropTypes) {

  return (
    <Transition.Root
      show={isOpen}
      as={Fragment}
    >
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={initialFocusRef}
        onClose={() => onClose?.()}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 transition-opacity bg-gray-400 bg-opacity-75" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex items-center justify-center min-h-full p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className={classNames('relative px-4 pt-5 pb-4 text-left transition-all transform bg-white rounded-lg shadow-xl grow md:grow-0 sm:my-8 sm:w-full sm:p-[30px]', {
                'sm:max-w-lg': size === 'sm',
                'sm:max-w-2xl': size === 'md',
                'sm:max-w-3xl': size === 'lg',
              })}
              >
                <div>
                  <div className="text-center">
                    <Dialog.Title
                      as="h3"
                      className="flex items-center justify-between text-xl font-semibold leading-6 text-gray-900"
                    >
                      {title}
                      <button
                        onClick={onClose}
                        className="p-[5px] rounded-md focus-visible:ring-primary-200 active:ring-primary-200 active:bg-gray-50"
                      >
                        <CrossIcon />
                      </button>
                    </Dialog.Title>
                    <div className="mt-2">
                      {content}
                    </div>
                  </div>
                </div>
                { actions
                  ? <div className="flex flex-row justify-center flex-1 gap-1 mt-5 sm:mt-6 ">
                  {
                    ...(actions ?? [])
                  }
                  </div>
                  : null }
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
